<template>
  <div>
    <v-tabs class="DashboardMenu__tabs pl-4">
      <v-tab
        v-if="projectType === ''"
        key="history"
        :to="`/project/${projectId}/history`"
        data-testid="dashboard-history"
      >{{ $t('history') }}
      </v-tab>

      <v-tab
        v-if="projectType === ''"
        key="stats"
        :to="`/project/${projectId}/stats`"
        data-testid="dashboard-stats"
      >{{ $t('project_stats') }}</v-tab>

      <v-tab key="activity" :to="`/project/${projectId}/activity`">{{ $t('activity') }}</v-tab>

      <v-tab
        v-if="canUpdateProject"
        key="settings"
        :to="`/project/${projectId}/settings`"
        data-testid="dashboard-settings"
      >{{ $t('settings') }}
      </v-tab>
    </v-tabs>

    <v-divider style="margin-top: -1px;" />
  </div>
</template>
<style lang="scss">
.DashboardMenu__tabs {
  .v-tab {
    min-width: auto !important;
    padding: 0 var(--zp-space-md) !important;
  }
}

@media (max-width: 700px) {
  .DashboardMenu__tabs {
    .v-tab {
      padding: 0 6px !important;
      font-size: 11px !important;
    }
  }
}
</style>
<script>

export default {

  props: {
    projectId: Number,
    projectType: String,
    canUpdateProject: Boolean,
  },

  computed: {
    // ZetaPilot: all Pro views unlocked. See App.vue:isPro for rationale.
    isPro() {
      return true;
    },
  },

  data() {
    return {
      id: null,
    };
  },

};
</script>
